import React from 'react';

// `icon` is the public/icons/<icon>.svg name used by the trace tree.
export const KIND_COLORS = {
  llm:       { bar: '#c084fc', tag: '#7c3aed', light: '#f3e8ff', label: 'LLM', icon: 'generate' },
  tool:      { bar: '#60a5fa', tag: 'var(--feedback-info)', light: '#dbeafe', label: 'Tool', icon: 'trace' },
  retrieval: { bar: '#34d399', tag: 'var(--feedback-success)', light: '#d1fae5', label: 'Retrieval', icon: 'retrieve' },
  agent:     { bar: 'var(--feedback-warning)', tag: '#b45309', light: '#fef3c7', label: 'Agent', icon: 'agent' },
  span:      { bar: 'var(--text-disabled)', tag: 'var(--text-secondary)', light: 'var(--surface-sunken)', label: 'Span', icon: 'span' },
};

export function colorForKind(kind) {
  // `generic` is the legacy key for an unkinded span — fold it into `span`.
  return KIND_COLORS[kind] || KIND_COLORS.span;
}

export default function KindTag({ kind }) {
  const color = colorForKind(kind);
  return (
    <span
      className="inline-block flex-none rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-ink-onBrand"
      style={{ backgroundColor: color.tag }}
    >
      {color.label}
    </span>
  );
}
